import useHash from '../../Hooks/UseHash';
import { NextBooking, PublicLiabilityInsuranceWithDocuments } from '../../Services/InsuranceLicenseService';
import InsuranceDocumentLinks from './InsuranceDocumentLinks';
import { bookingHeader, bookingStatus, formatUnixDate } from './InsuranceLicenseUtils';
import LiabilityInsuranceMobileList from './LiabilityInsuranceMobileList';

type Props = {
	policies: PublicLiabilityInsuranceWithDocuments[];
	firstBookingForStatus: NextBooking;
	firstBooking?: NextBooking;
	secondBooking?: NextBooking;
	removingPolicyId: number | null;
	onRemovePolicy: (policyId: number) => void;
};

export default function LiabilityInsuranceTable(props: Props) {
	const { policies, firstBookingForStatus, firstBooking, secondBooking, removingPolicyId, onRemovePolicy } = props;
	const hash = useHash();

	return (
		<div className="liability-insurance-table-region">
			<div className="insurance-license-desktop-table">
				<table className="table table-striped">
					<thead>
						<tr>
							<th>Insurance provider</th>
							<th className="d-mobile-none">Policy number</th>
							<th className="d-mobile-none">Valid from</th>
							<th>Expiry</th>
							<th className="d-mobile-none">Documents</th>
							<th className="d-mobile-none text-center">{bookingHeader(firstBooking)}</th>
							<th className="d-mobile-none text-center">{bookingHeader(secondBooking)}</th>
							<th className="d-mobile-none"></th>
						</tr>
					</thead>
					<tbody>
						{policies.map((policy) => {
							const firstStatus = bookingStatus(policy, firstBookingForStatus);
							const secondStatus = bookingStatus(policy, secondBooking);
							return (
								<tr key={policy.PublicLiabilityInsuranceId}>
									<td className="truncate-characters-30">
										{policy.PublicLiabilityInsuranceIssuedBy || '-'}
									</td>
									<td className="d-mobile-none">{policy.PublicLiabilityInsuranceNumber || '-'}</td>
									<td className="d-mobile-none">
										{formatUnixDate(policy.PublicLiabilityInsuranceValidFrom)}
									</td>
									<td>{formatUnixDate(policy.PublicLiabilityInsuranceExpiry)}</td>
									<td className="d-mobile-none">
										<InsuranceDocumentLinks documents={policy.Documents} hash={hash} />
									</td>
									<td className="d-mobile-none text-center">
										{firstStatus ? (
											<span className={firstStatus.className}>{firstStatus.label}</span>
										) : null}
									</td>
									<td className="d-mobile-none text-center">
										{secondStatus ? (
											<span className={secondStatus.className}>{secondStatus.label}</span>
										) : null}
									</td>
									<td className="d-mobile-none">
										<button
											type="button"
											className="insurance-license-action-link"
											disabled={removingPolicyId === policy.PublicLiabilityInsuranceId}
											onClick={() => onRemovePolicy(policy.PublicLiabilityInsuranceId)}
										>
											{removingPolicyId === policy.PublicLiabilityInsuranceId
												? 'Removing...'
												: 'Remove'}
										</button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>

			<div className="insurance-license-mobile-only">
				<LiabilityInsuranceMobileList
					policies={policies}
					firstBookingForStatus={firstBookingForStatus}
					firstBooking={firstBooking}
					secondBooking={secondBooking}
					removingPolicyId={removingPolicyId}
					onRemovePolicy={onRemovePolicy}
				/>
			</div>
		</div>
	);
}
